import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailHistoryService } from './email-history.service';
import { DetailCampaignResponse, EmailCampaignProps, SearchParams } from './email-history.model';
import { finalize, map, tap } from 'rxjs/operators';
import { FormBuilder } from '@angular/forms';
import { AppService } from '../../app.service';
import { Paginator } from 'primeng/paginator';

@Component({
  selector: 'app-email-history',
  templateUrl: './email-history.component.html',
  styleUrls: ['./email-history.component.scss']
})
export class EmailHistoryComponent implements OnInit {
  @ViewChild('dialog', { static: true }) dialogRef: TemplateRef<unknown>;
  @ViewChild('confirmDialog', { static: true }) confirmDialogRef: TemplateRef<unknown>;
  @ViewChild('paginator', { static: true }) paginator: Paginator;

  campaignList: EmailCampaignProps[] = [];
  campaignListTotalRecord = 0;
  campaignDetailList: DetailCampaignResponse;
  currentCampaign: EmailCampaignProps = null;
  currentCampaignName = '';
  currentCampaignContent = '';
  onRequesting = false;
  delayToCancelCloseAllDialog: any;
  searchForm = this.fb.group({
    campaign_name: [''],
    create_time: [''],
    send_time: ['']
  });
  countryType = {
    only_jp: 'Japan',
    not_jp: 'Others than Japan',
    all: 'All Countries'
  };
  option = [
   'Specified IBs',
   'IBs\' Direct Child Traders',
   'Full IB Network'
  ];
  showDetailDialog = false;
  pageInfo = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  cpListPageInfo = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  }
  statusColors = {
    'Cancelled': '#da6868',
    'In Progress': '#E98740',
    'Done': '#599B8F',
    'Scheduled': '#BE36D1',
  };
  mainTypes = {
    'admin': 'Admin',
    'notice': 'Notice',
    'noreply': 'No Reply',
    'support': 'Support',
  }
  currentSearchParams: SearchParams = {
    campaign_name: '',
    create_time: 0,
    send_time: 0
  };
  constructor(
    public readonly dialog: MatDialog,
    private readonly mailService: EmailHistoryService,
    private readonly fb: FormBuilder,
    private readonly as: AppService
  ) { }

  ngOnInit(): void {
    this.getCampaigns();
  }

  getCampaigns(params = {}) {
     this.mailService.getCampaignHistory({ ...params, ...{page_size: '10'} }).pipe(
      tap(r => {
        this.campaignListTotalRecord = r.data.paging.total;

      })
    ).subscribe(e => {
       this.campaignList = e.data.campaigns;
       this.cpListPageInfo = {
         pageIndex: e.data.paging.page,
         pageSize: e.data.paging.page_size,
         totalRecord: e.data.paging.total,
       }
     });
  }

  onPage(e) {
    this.getCampaigns({page: e, ...this.currentSearchParams});
  }

  onPageOfMail(page: number) {
    this.getMailListDetail(this.currentCampaign.id, {page});
  }

  resetSearch() {
    this.getCampaigns();
    this.searchForm.reset({
      campaign_name: '',
      create_time: '',
      send_time: ''
    });
  }

  onSearch() {
    const val = this.searchForm.getRawValue() as SearchParams;
    const p = {
      campaign_name: val.campaign_name,
      ...((String(val.create_time)).length !== 0 && { create_time: new Date(val.create_time).getTime() }),
      ...((String(val.send_time)).length !== 0 && { send_time: new Date(val.send_time).getTime() }),
    } as SearchParams;
    if(p.create_time && p.send_time && (p.create_time > p.send_time)) {
      return this.as.showError('Created time must be less than Send time.')
    }
    this.cpListPageInfo.pageIndex = 1
    this.currentSearchParams = p;
    this.getCampaigns(p);
  }

  getMailListDetail(id: number, params = {}) {
    this.mailService.getDetail(id.toString(), { ...params, page_size: '10' }).subscribe({
      next: (r) => {
        this.campaignDetailList = r;
        const {page, total} = r.data.paging;
        this.pageInfo = {
          pageIndex: page,
          pageSize: 10,
          totalRecord: total
        }
      }
    });
  }

  openDetail(campaign: EmailCampaignProps): void {
    this.currentCampaign = campaign;
    this.currentCampaignContent = campaign.content.text;
    this.getMailListDetail(campaign.id);
    this.showDetailDialog = true;
  }

  onCancelClicked(campaignName: string | number) {
    this.currentCampaignName = String(campaignName);
    this.dialog.open(this.confirmDialogRef, {
      minWidth: '20%'
    });
  }

  cancel() {
    this.onRequesting = true;
    this.mailService.cancelRequest({ campaign_id: this.currentCampaignName }).pipe(
      finalize(() => {this.onRequesting = false;})
    ).subscribe({
      next: (r) => {
        this.getCampaigns();
        this.showDetailDialog = false;
      },
    });
  }

  ngOnDestroy() {
    clearTimeout(this.delayToCancelCloseAllDialog);
  }

}
